export const videoUrlValidator = (input: string) => {
  const regex = /https:\/\/www\.youtube|https:\/\/|www|youtube/;
  return regex.test(input);
};

export const threeDModelUrlValidator = (input: string) => {
  const regex = /https:\/\/.*scene\.splinecode/;
  return regex.test(input);
};

export const httpsUrlValidator = (input: string) => {
  try {
    const url = new URL(input);
    return url.protocol === 'https:';
  } catch {
    return false;
  }
};
